import type { ReactElement } from 'react';

/** 카카오 로그인 버튼의 말풍선 심볼 — 글자 색(currentColor)을 따르고 크기는 버튼이 정한다. 꾸밈이라 보조기기에서 감춘다. */
export const KakaoIcon = (): ReactElement => (
  <svg viewBox="0 0 24 24" aria-hidden fill="currentColor">
    <path d="M12 3C6.48 3 2 6.58 2 11c0 2.86 1.88 5.37 4.7 6.78-.2.74-.74 2.7-.85 3.12-.13.52.19.51.4.37.17-.11 2.65-1.8 3.72-2.53.66.1 1.33.15 2.03.15 5.52 0 10-3.58 10-8s-4.48-8-10-8Z" />
  </svg>
);
